// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e443290e","977":"fa62bb02"}[chunkId] + ".chunk.js";
};